if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          // window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* Velsa mask PDP galleries: silent autoplay of the visible Shopify video only. */
;(() => {
  const handles = new Set(['the-silk-eye-mask-blue', 'the-silk-eye-mask-white',
    'the-silk-eye-mask-pink', 'the-silk-eye-mask-black', 'the-silk-eye-mask-blush-pink']);
  const handle = location.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
  if (!handles.has(handle) || window.__velsaMaskGalleryAutoplay) return;
  window.__velsaMaskGalleryAutoplay = true;
  const selector = 'media-gallery[id^="MediaGallery-template--"][id$="__main"]';
  const controllers = new Map();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  function hosted(video) {
    return [video.getAttribute('src'), ...Array.from(video.querySelectorAll('source'), s => s.getAttribute('src'))]
      .filter(Boolean).some(src => {
        try {
          const url = new URL(src, location.href);
          return /^https?:$/.test(url.protocol) &&
            (/(^|\.)shopify(?:cdn)?\.(com|net)$/.test(url.hostname) ||
              (url.hostname === location.hostname && /\/cdn\/shop\/videos\//.test(url.pathname)));
        } catch (_) { return false; }
      });
  }
  function configure(video) {
    video.defaultMuted = video.muted = true;
    video.playsInline = video.loop = video.autoplay = video.controls = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }
  function attach(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    const list = viewer?.querySelector('[id^="Slider-Gallery-"]');
    if (!list) return null;
    const abort = new AbortController(), records = new Map(), observedSlides = new Set();
    const options = { signal: abort.signal };
    let frame = 0, current = null;
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    function pause(record) {
      const video = record.video;
      if (!video || (video.paused && !record.pending)) return;
      record.automatic = false;
      if (!video.paused) record.ignorePause = true;
      video.pause();
    }
    function bind(record, video) {
      if (!video || record.video === video) return;
      record.video = video;
      configure(video);
      video.addEventListener('pause', () => {
        if (record.ignorePause) { record.ignorePause = false; return; }
        if (record === current && !document.hidden && !video.ended) {
          record.manualPause = true;
          record.automatic = false;
        }
      }, options);
      video.addEventListener('play', () => {
        record.manualPause = record.blocked = false;
        if (!record.pending) record.automatic = false;
        schedule();
      }, options);
    }
    function recordFor(slide) {
      if (!slide || slide.parentElement !== list) return null;
      if (!records.has(slide)) {
        const deferred = slide.querySelector('deferred-media');
        const templateVideo = deferred?.querySelector('template')?.content.querySelector('video');
        if (templateVideo && hosted(templateVideo)) records.set(slide, { deferred, templateVideo });
      }
      const record = records.get(slide);
      if (record) bind(record, record.deferred.querySelector('video'));
      return record;
    }
    const originalPlay = gallery.playActiveMedia;
    const hadOwnPlay = Object.prototype.hasOwnProperty.call(gallery, 'playActiveMedia');
    const wrappedPlay = function (activeItem) {
      if (recordFor(activeItem)) { schedule(); return; }
      for (const record of records.values()) if (record.video && !record.video.paused) record.ignorePause = true;
      if (typeof originalPlay === 'function') originalPlay.call(this, activeItem);
      schedule();
    };
    gallery.playActiveMedia = wrappedPlay;
    function update() {
      frame = 0;
      if (!gallery.isConnected) return;
      const slides = Array.from(list.children).filter(slide => slide.matches('li[data-media-id]'));
      for (const slide of slides) {
        recordFor(slide);
        if (!observedSlides.has(slide)) { observedSlides.add(slide); intersection.observe(slide); }
      }
      for (const slide of observedSlides) {
        if (!slide.isConnected || slide.parentElement !== list) { intersection.unobserve(slide); observedSlides.delete(slide); }
      }
      for (const [slide, record] of records) {
        if (!slide.isConnected) { pause(record); records.delete(slide); }
      }
      const clip = viewer.getBoundingClientRect();
      let chosen = null, best = 0;
      for (const slide of slides) {
        const rect = slide.getBoundingClientRect();
        if (rect.width < 2 || rect.height < 2 || getComputedStyle(slide).visibility === 'hidden') continue;
        const width = Math.max(0, Math.min(rect.right, clip.right, innerWidth) - Math.max(rect.left, clip.left, 0));
        const height = Math.max(0, Math.min(rect.bottom, clip.bottom, innerHeight) - Math.max(rect.top, clip.top, 0));
        const score = width / rect.width * height / Math.min(rect.height, innerHeight);
        if (width / rect.width >= 0.6 && score >= 0.35 && score > best) { chosen = slide; best = score; }
      }
      current = records.get(chosen) || null;
      for (const record of records.values()) if (document.hidden || record !== current) pause(record);
      if (document.hidden || !current) return;
      if (reducedMotion.matches) { if (current.automatic) pause(current); return; }
      if (current.manualPause || current.blocked || current.pending) return;
      const record = current;
      let newlyLoaded = false;
      if (!record.video) {
        if (typeof record.deferred.loadContent !== 'function') return;
        configure(record.templateVideo);
        // Dawn's loader pauses media first; do not mistake that for a visitor pause.
        for (const other of records.values()) if (other.video && !other.video.paused) other.ignorePause = true;
        record.pending = record.automatic = newlyLoaded = true;
        try { record.deferred.loadContent(false); }
        catch (_) { record.pending = false; record.blocked = true; return; }
        bind(record, record.deferred.querySelector('video'));
      }
      const video = record.video;
      if (!video) { record.pending = false; return; }
      if (!video.paused && !newlyLoaded) return;
      record.pending = record.automatic = true;
      video.muted = true;
      try {
        Promise.resolve(video.play()).catch(error => {
          if (error.name !== 'AbortError') record.blocked = true;
          video.controls = true;
        })
          .finally(() => { record.pending = false; });
      } catch (_) { record.pending = false; record.blocked = true; }
    }
    const mutation = new MutationObserver(schedule);
    mutation.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    const intersection = new IntersectionObserver(schedule, { threshold: [0, 0.01, 0.35, 0.6, 1] });
    intersection.observe(viewer);
    // EZFY moves the list with a CSS transform; its viewport itself never moves.
    viewer.addEventListener('transitionend', schedule, options);
    viewer.addEventListener('transitioncancel', schedule, options);
    document.addEventListener('scroll', schedule, { ...options, passive: true, capture: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) for (const record of records.values()) pause(record);
      schedule();
    }, options);
    window.addEventListener('resize', schedule, { ...options, passive: true });
    reducedMotion.addEventListener('change', schedule, options);
    customElements.whenDefined('deferred-media').then(() => { if (gallery.isConnected) schedule(); });
    schedule();
    return () => {
      abort.abort(); mutation.disconnect(); intersection.disconnect(); cancelAnimationFrame(frame);
      for (const record of records.values()) pause(record);
      if (gallery.playActiveMedia === wrappedPlay) {
        if (hadOwnPlay) gallery.playActiveMedia = originalPlay; else delete gallery.playActiveMedia;
      }
    };
  }
  let scanFrame = 0;
  function scan() {
    scanFrame = 0;
    for (const [gallery, destroy] of controllers) if (!gallery.isConnected) { destroy(); controllers.delete(gallery); }
    document.querySelectorAll(selector).forEach(gallery => {
      if (!controllers.has(gallery)) { const destroy = attach(gallery); if (destroy) controllers.set(gallery, destroy); }
    });
  }
  const observer = new MutationObserver(() => { if (!scanFrame) scanFrame = requestAnimationFrame(scan); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
